import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/home';

export default function FeaturedArticles() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-14">
          <div>
            <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              热门推荐
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              精选亚洲各地优质内容
            </h2>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-foreground-800">
                  {article.categoryName}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2.5 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-secondary-200 flex items-center justify-center">
                      <span className="text-[10px] font-medium text-secondary-700">
                        {article.author.charAt(0)}
                      </span>
                    </div>
                    <span>{article.author}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-xs"></i>
                      {article.views.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}